import { FC, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { forgotpasswordSchema } from "../../validation/forgotPassword";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { ForgotPasswordResponseType } from "./types";
import { LoaderContext } from "../../context/loaderContext";
import {TextAlignProps} from "../../components/contactAndSafetyInfo/types";
import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
import { Link } from "react-router-dom";
import {BVLogo} from "../../assets";

const HubForgotPassword: FC = (): JSX.Element => {
  const { control, handleSubmit, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(forgotpasswordSchema),
  });
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);





  const { loading, error, data, mutate, removeErrorAndData } = useFetch<null, null, ForgotPasswordResponseType>(APIEndpoints.USER_FORGOT_PASSWORD);

  useEffect(() => {
    if (data || error) {
      hideLoader();
      if (data) {
        const { message } = data;
        showToast([message], ToastTypes.SUCCESS);
        reset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const submitForm = async (values: { email: string }) => {
    setLoader();
    if ((error && error.length > 0) || data) removeErrorAndData();

    mutate({ user: values });
  };




  return (
    <div className="container-fluid login-sec d-flex flex-fill flex-column justify-content-between overflow-auto">
      <div className="container d-flex flex-fill flex-column py-4 px-0 py-lg-4 px-lg-4">
        <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END}/>
        <div className="col-12 col-sm-10 col-md-6 col-lg-6 col-xl-6 mt-5">
          <div className="card mb-4">
            <div className="card-header p-3">
              <h1 className="m-0 fw-bold">Forgot your password?</h1>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit(submitForm)} className="forgot-formlabel">
                <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    render={({field, fieldState: {error}}) => (
                        <HubInputField
                            inputId="email"
                            isRowBased={false}
                            isRequired={true}
                            field={field}
                            error={error}
                            inputLabel="Email"
                            inputType="email"
                        />
                    )}
                />
                <button disabled={loading} className="btn btn-primary" type="submit">
                  {loading ? (<i className="spinner-border me-2"></i>) : null}
                  Send me reset password instructions
                </button>
                <p className="mb-2 mt-1">
                  <Link to="/users/sign_in" className="text-decoration-none">
                    Login
                  </Link>
                </p>
              </form>
            </div>
          </div>
          <div className="bg-white p-md-0 p-3 rounded-3">
            <div className="row">
              <div className="col-12 col-lg-3">
                <img className="img-fluid" width={180} src={BVLogo} alt="Products Logos"/>
              </div>
              <p className="copyright-text col m-0">
                This site is intended for US health care professionals. StimRouter is a registered trademarks of
                Bioness
                Inc.
                All other trademarks are property of their respective owners. ©2021 Bioventus LLC
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubForgotPassword;
